import styled from "@emotion/styled";
var RatingContainer = /*#__PURE__*/ styled("span", {
    target: "e1dj31050"
})("display:inline-flex;column-gap:1px;");
export { RatingContainer };
